export default __webpack_public_path__ + "static/media/ic-file-upload.4f1c23e9.svg";